import { AppConfig } from "../types";

export const config: AppConfig = {
  dashboardApi: process.env.REACT_APP_DASHBOARD_API || "",
  whatsappApi: process.env.REACT_APP_WHATSAPP_API || "",
  stage: process.env.REACT_APP_STAGE || "dev",
};

// Telas liberadas neste build (REACT_APP_SCREENS, separadas por espaço).
export const screensHabilitadas: string[] = (process.env.REACT_APP_SCREENS || "")
  .split(" ")
  .filter(Boolean);

export const temTela = (screen: string): boolean => screensHabilitadas.includes(screen);

export const authConfig = {
  authUrl:
    process.env.REACT_APP_AUTH_URL ||
    "https://uxumwgj2gk.execute-api.us-west-2.amazonaws.com",
};

export const userManagementConfig = {
  userManagementApi: process.env.REACT_APP_USER_MANAGEMENT_API || "",
};

// clientes-backend public API base URL. The RBAC catalog (GET /catalog) is public and
// clientes-backend is unreachable from the gestor VPC, so the gestor browser fetches it
// directly here rather than via a gestor-backend proxy.
export const clientesConfig = {
  clientesApi:
    process.env.REACT_APP_CLIENTES_API ||
    "https://wvkdy56bn8.execute-api.us-west-2.amazonaws.com/dev",
};

// Validation
if (!config.dashboardApi) {
  throw new Error("REACT_APP_DASHBOARD_API is required");
}

if (!config.whatsappApi) {
  throw new Error("REACT_APP_WHATSAPP_API is required");
}

export default config;
